export const authConfig: any = {
    auth: {
      clientId: process.env.REACT_APP_AD_CLIENT_ID,
      redirectUri: process.env.REACT_APP_AD_REDIRECT_URL,
      scopes : ['user.read'],
      authority: "https://login.microsoftonline.com/852c5799-8134-4f15-9d38-eba4296cc76f",
      postLogoutRedirectUri: window.location.origin
    },
    cache: {
      cacheLocation: "sessionStorage", 
      storeAuthStateInCookie: true 
    }
};